import Vuex from 'vuex';
import Vue from 'vue';
import createPersistedState from 'vuex-persistedstate'

// Modules 
import invoice from './stores/invoiceStore'
import all from './stores/all'
import company from './stores/companyStore';
import user from './stores/userStore';
import auth from './stores/authStore';
import global from './stores/globalStore'
import contact from './stores/contactStore';

Vue.use(Vuex);

export default new Vuex.Store({
    // strict: true,
	modules:{
        invoice,
        company,
        user,
        auth,
        global,
        contact
    },
    plugins: [createPersistedState()],
})